import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { IRequirementMast } from "../../../models/RequirementMast";
import { TableSkill } from "./TableSkill";
import { TableAll } from "./TableAll";
import { TableMy } from "./TableMy";
import { ILogin } from "../../../models/Login";
import Confetti from 'react-confetti';
import TextTransition from "react-text-transition";
import { TablePublished } from "./TablePublished";

export interface IModel {
    open: boolean,
    singleData: IRequirementMast
}


export const RecruiterRequirementMast = (permissions: { tab: number, is_Create?: boolean, is_Delete?: boolean, is_Update?: boolean, is_Export?: boolean, is_View?: boolean }) => {
    const toast = useRef<any>(null);
    const [reload, setReload] = useState(false);
    const [celebrate, setCelebrate] = useState<boolean>(false);
    const [index, setIndex] = useState(0);

    const ShowCelebration = () => {
        setCelebrate(true); setTimeout(() => setCelebrate(false), 10000);

    }
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const TEXTS = ["You", "Did", "It!", `${loginObj.name}`, "Todays Target Completed"];

    const colors = ["#ff595e", "green", "#edae49"];

    const springConfig: any = { stiffness: 50, damping: 30 };

    useEffect(() => {
        if (celebrate) {
            const intervalId = setInterval(
                () => setIndex((index) => index + 1),
                2000
            );
            return () => { clearTimeout(intervalId); setIndex(0) }
        }
    }, [celebrate]);

    return (
        <>
            {permissions.tab === 1 && <TableAll permissions={permissions} toast={toast} reload={reload} setReload={setReload} />}
            {permissions.tab === 2 && <TableMy permissions={permissions} toast={toast} reload={reload} setReload={setReload} ShowCelebration={ShowCelebration} />}
            {permissions.tab === 3 && <TableSkill permissions={permissions} toast={toast} reload={reload} setReload={setReload} />}
            {permissions.tab === 4 && <TablePublished permissions={permissions} toast={toast} reload={reload} setReload={setReload} ShowCelebration={ShowCelebration} />}
            <Toast ref={toast} />
            {celebrate && (
                <Confetti width={window.innerWidth} height={window.innerHeight} gravity={0.2} numberOfPieces={3500} />
            )}
            <div style={{ position: "absolute", top: '50%', left: '50%', transform: " translate(-50%, -50%)" }}>
                {celebrate && (
                    <TextTransition className="m-6 " style={{ color: colors[index % colors.length], alignContent: "center" }} springConfig={springConfig}><h1 style={{ fontSize: '100px', alignContent: "center", marginLeft: "40px" }}>{TEXTS[index % TEXTS.length]}&#127881;</h1></TextTransition>
                )}
            </div>
        </>
    );
}
